<template>
    <div :style="{ aspectRatio: ratio }" class="youtube-player">
        <LoaderBlock v-if="loaderDisplay" />
        <!--        <template v-if="preview && !isFirstPlaying && !videoUnAvailable">
            <img :key="preview" class="youtube-player__preview" :src="preview" :alt="preview" />
            <button v-if="!loaderDisplay" type="button" class="youtube-player__button-play">
                <img src="@images/portal/cta-play-icon-black.svg" alt=">" />
            </button>
        </template>-->
        <div v-if="youtube_code" :id="componentId" class="youtube-player__iframe"></div>
        <iframe
            class="youtube-player__iframe"
            v-else
            :src="videoUrl"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer;clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
        ></iframe>
    </div>
</template>

<script>
import LoaderBlock from "@components/Loaders/LoaderBlock"
import { EventBus, EventsList } from "~events"
import { timeToSecond } from "@helpers"
/* eslint-disable */
export default {
    name: "YoutubePlayer",
    components: { LoaderBlock },
    props: {
        videoUrl: {
            type: String
        },
        ratio: {
            type: Number
        },
        preview: {
            type: String
        },
        infoUnitId: {
            type: [Number, String],
            required: false
        }
    },
    data() {
        return {
            youtubePreviews: [],
            youtube_code: null,
            componentId: null,
            playerYT: null,
            isFirstPlaying: false,
            isEnded: false,
            isPaused: false,
            isPlaying: false,
            videoStart: null,
            checkTimeTimer: null,
            loaderDisplay: true,
            videoUnAvailable: false,
        }
    },
    created() {
        this.youtube_code = this.extractYoutubeKey(this.videoUrl)
        this.videoStart = this.extractStart(this.videoUrl)
        this.getYoutubePreviews()
        EventBus.$on(EventsList.VIDEO_SET_SEEK, ({ unitId, seekTo }) => {
            if (this.infoUnitId === unitId) {
                if (this.playerYT) {
                    this.playerYT.seekTo(seekTo)
                } else {
                    console.info("[seek to]: Youtube player no init")
                }
            }
        })
    },
    mounted() {
        this.componentId = "ytb-id-" + this._uid
        if (this.youtube_code) {
            this.initScript()
        }
    },
    methods: {
        initScript() {
            if (!window.YT) {
                const tag = document.createElement("script")

                tag.src = "https://www.youtube.com/iframe_api"
                const firstScriptTag = document.getElementsByTagName("script")[0]
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
            }
            setTimeout(() => {
                this.initPlayer()
            }, 500)
        },
        initPlayer() {
            if (!window.YT || !window.YT.Player) {
                setTimeout(() => this.initScript(), 100)
                return
            }

            // Make sure API is fully ready
            if (window.YT.PlayerState) {
                // Create player only when API is ready
                this.createPlayer()
            } else {
                setTimeout(() => this.initPlayer(), 100)
            }
        },
        createPlayer() {
            const playerVars = {
                rel: 0,
                showinfo: 0,
                modestbranding: 1,
                autoplay: 0,
                enablejsapi: 1,
                origin: window.location.origin,
                playsinline: 1,
            }
            if (!this.videoStart) this.videoStart = timeToSecond(this.videoUrl)
            if (this.videoStart) playerVars["start"] = this.videoStart
            this.playerYT = new window.YT.Player(this.componentId, {
                height: "360",
                width: "640",
                videoId: this.youtube_code,
                playerVars: playerVars,
                events: {
                    onReady: this.onPlayerReady,
                    onStateChange: this.onPlayerStateChange
                }
            })
        },
        extractYoutubeKey(url) {
            const regExp =
                /^.*(?:(?:youtu\.be\/|v\/|vi\/|live\/|u\/\w\/|embed|shorts|\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/
            let match = url.match(regExp)
            let videoId = null
            if (match) {
                if (match[7] && match[7].length == 11) {
                    videoId = match[7]
                } else if (match[1] && match[1].length == 11) {
                    videoId = match[1]
                }
            }
            return videoId || false
        },
        extractStart(url_string) {
            let url = new URL(url_string)
            return parseInt(url.searchParams.get("t"))
        },
        checkTime(ended = false) {
            if (ended) {
                clearInterval(this.checkTimeTimer)
                this.emitTimeUpdate(true)
            } else {
                this.checkTimeTimer = setInterval(() => {
                    this.emitTimeUpdate()
                }, 1000)
            }
        },
        emitTimeUpdate(finish = false) {
            let player = this.playerYT

            if (
                player &&
                typeof player.getCurrentTime === 'function' &&
                typeof player.getDuration === 'function'
            ) {
                let currentTime = player.getCurrentTime()
                let duration = player.getDuration()

                if (finish) {
                    currentTime = player.getDuration()
                }

                this.$emit("timeupdate", {
                    seconds: currentTime,
                    duration: duration
                })
            }
        },
        onPlayerStateChange(event) {
            const state = window.YT.PlayerState
            this.isEnded = event.data === state.ENDED
            this.isPaused = event.data === state.PAUSED
            this.isPlaying = event.data === state.PLAYING
            this.videoUnAvailable = event.data === state.UNSTARTED

            if (!this.isFirstPlaying) {
                this.$emit("play")
                this.isFirstPlaying = event.data === state.UNSTARTED
            }
            if (this.isPaused) {
                this.$emit("pause")
                clearInterval(this.checkTimeTimer)
                this.emitTimeUpdate()
            }
            if (this.isEnded) {
                this.$emit("ended")
                this.checkTime(true)
            }
            if (this.isPlaying) {
                this.checkTime()
            }
        },
        onPlayerReady(event) {
            //this.videoUnAvailable = this.playerYT.getPlayerState() === window.YT.PlayerState?.UNSTARTED
            // console.log("onPlayerReady", event)
            this.videoUnAvailable = false
            this.loaderDisplay = false
            this.$emit("ready", this.playerYT)
           // this.playerYT.playVideo()
        },
        getImageSize(url) {
            return new Promise((resolve, reject) => {
                function youtubeCheck(e) {
                    const thumbnail = ["maxresdefault", "sddefault", "hqdefault", "mqdefault", "default"]
                    if (e.naturalWidth === 120 && e.naturalHeight === 90) {
                        const url = e.getAttribute("src")
                        for (let i = 0, len = thumbnail.length - 1; i < len; i++) {
                            if (url.indexOf(thumbnail[i]) > 0) {
                                e.setAttribute("src", url.replace(thumbnail[i], thumbnail[i + 1]))
                                break
                            }
                        }
                    }
                    return e.getAttribute("src")
                }
                const image = new Image()
                image.onload = () =>
                    resolve({
                        width: image.width,
                        height: image.height,
                        link: youtubeCheck(image)
                    })
                image.onerror = reject
                image.src = url
            })
        },
        getYoutubePreviews() {
            const key = this.youtube_code
            this.getImageSize("https://img.youtube.com/vi/" + key + "/maxresdefault.jpg").then(sizes => {
                let path = sizes.link

                this.youtubePreviews.push(path)

                path = "https://img.youtube.com/vi/" + key + "/maxres1.jpg"

                this.youtubePreviews.push(path)

                EventBus.$emit(EventsList.GET_YOUTUBE_PREVIEWS, {
                    id: this.youtube_code,
                    previews: this.youtubePreviews
                })
            })
        },
    }
}
/* eslint-enable */
</script>

<style lang="sass">
.youtube-player
    &__iframe
        width: 100%
        height: 100%
</style>
<style scoped lang="sass">
.custom-input__file-area .youtube-player
    height: 222px
    &__button-play
        width: 45px
        height: 45px
.youtube-player
    width: 100%
    height: auto
    aspect-ratio: 16 / 9
    position: relative
    @media (max-width: 1370px)
        height: 410px
    @media (max-width: 1300px)
        height: 560px
    @media (max-width: 1100px)
        height: 506px
    @media (max-width: 990px)
        height: 400px !important
    @media (max-width: 767px)
        height: 330px !important
    @media (max-width: 640px)
        height: 225px !important
    @media (max-width: 480px)
        height: 210px !important
    @media (max-width: 400px)
        height: 195px !important
    @media (max-width: 375px)
        height: 165px !important
    .loader-block
        position: absolute
        top: 0
        right: 0
        left: 0
        bottom: 0
        z-index: 1
        height: 100%
        background-color: rgba(0,0,0, 0.50)
    &__preview
        width: 100%
        height: 100%
        position: absolute
        top: 0
        right: 0
        left: 0
        display: block
        pointer-events: none
        object-fit: cover
    &__button-play
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
        width: 70px
        height: 70px
        z-index: 1
        opacity: .7
        pointer-events: none
        @media (max-width: 990px)
            width: 55px
            height: 55px
        @media (max-width: 640px)
            width: 45px
            height: 45px
        img
            width: 100%
            height: 100%
</style>
